import React, { ComponentType, useContext } from 'react'

type ErrorContext = {
    notifyError: (msg?: string) => void
}

const ctx = React.createContext<ErrorContext>(
    // @ts-ignore
    null
)

export type ErrorHandlingProps = {
    defaultErrorMsg: string
    children: React.ReactNode
}

export const ErrorHandling: ComponentType<ErrorHandlingProps> = ({
    children,
    defaultErrorMsg
}) => {
    const notifyError = (msg?: string) => {
        window.alert(msg || defaultErrorMsg)
    }
    return (
        <ctx.Provider
            value={{
                notifyError
            }}
        >
            {children}
        </ctx.Provider>
    )
}

export const useErrorHandling = (): ErrorContext => useContext(ctx)
